import { replaceWords } from "../services/filter-value";

window.replaceWords = replaceWords;